var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import connectToParent from 'penpal/lib/connectToParent';
import { isInitParent, isOnBootParent, isRenderConfigScreenParent, isRenderFieldExtensionParent, isRenderManualFieldExtensionConfigScreenParent, isRenderModalParent, isRenderPageParent, isRenderSidebarPaneParent, } from './guards';
function toMultifield(fn) {
    return function (fields, ctx) {
        if (!fn) {
            return {};
        }
        var result = {};
        for (var _i = 0, fields_1 = fields; _i < fields_1.length; _i++) {
            var field = fields_1[_i];
            var itemType = ctx.itemTypes[field.relationships.item_type.data.id];
            result[field.id] = fn(field, __assign(__assign({}, ctx), { itemType: itemType }));
        }
        return result;
    };
}
var buildRenderUtils = function (parent) {
    var oldHeight = null;
    var updateHeight = function (height) {
        var realHeight = height === undefined
            ? Math.ceil(document.documentElement.getBoundingClientRect().height)
            : height;
        if (realHeight !== oldHeight) {
            parent.setHeight(realHeight);
            oldHeight = realHeight;
        }
    };
    var autoResizingActive = false;
    var mutationObserver = null;
    var resetHeight = function () { return updateHeight(); };
    var startAutoResizer = function () {
        updateHeight();
        if (autoResizingActive) {
            return;
        }
        autoResizingActive = true;
        mutationObserver = new MutationObserver(resetHeight);
        mutationObserver.observe(window.document.body, {
            attributes: true,
            childList: true,
            subtree: true,
            characterData: true,
        });
        window.addEventListener('resize', resetHeight);
    };
    var stopAutoResizer = function () {
        if (!autoResizingActive) {
            return;
        }
        autoResizingActive = false;
        if (mutationObserver) {
            mutationObserver.disconnect();
        }
        window.removeEventListener('resize', resetHeight);
    };
    return { updateHeight: updateHeight, startAutoResizer: startAutoResizer, stopAutoResizer: stopAutoResizer };
};
export function connect(configuration) {
    if (configuration === void 0) { configuration = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var mainNavigationTabs, settingsAreaSidebarItemGroups, contentAreaSidebarItems, manualFieldExtensions, itemFormSidebarPanels, listener, penpalConnection, parent, initialSettings, render, render, renderUtils_1, render, renderUtils_2, render, renderUtils_3, render, renderUtils_4, render, renderUtils_5, render;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    mainNavigationTabs = configuration.mainNavigationTabs, settingsAreaSidebarItemGroups = configuration.settingsAreaSidebarItemGroups, contentAreaSidebarItems = configuration.contentAreaSidebarItems, manualFieldExtensions = configuration.manualFieldExtensions, itemFormSidebarPanels = configuration.itemFormSidebarPanels;
                    listener = null;
                    penpalConnection = connectToParent({
                        methods: {
                            sdkVersion: function () { return '0.2.0'; },
                            implementedHooks: function () {
                                return Object.fromEntries(Object.entries(configuration).map(function (_a) {
                                    var key = _a[0], value = _a[1];
                                    if (typeof value === 'function') {
                                        return [key, true];
                                    }
                                    return [key, value];
                                }));
                            },
                            mainNavigationTabs: mainNavigationTabs,
                            settingsAreaSidebarItemGroups: settingsAreaSidebarItemGroups,
                            contentAreaSidebarItems: contentAreaSidebarItems,
                            manualFieldExtensions: manualFieldExtensions,
                            itemFormSidebarPanels: itemFormSidebarPanels,
                            overrideFieldExtensions: toMultifield(configuration.overrideFieldExtensions),
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            onChange: function (newSettings) {
                                if (listener) {
                                    listener(newSettings);
                                }
                            },
                            validateManualFieldExtensionParameters: configuration.validateManualFieldExtensionParameters,
                        },
                    });
                    return [4 /*yield*/, penpalConnection.promise];
                case 1:
                    parent = _a.sent();
                    return [4 /*yield*/, parent.getSettings()];
                case 2:
                    initialSettings = _a.sent();
                    if (isInitParent(parent, initialSettings)) {
                        // Nothing to do. Parent calls the method they need.
                    }
                    if (isOnBootParent(parent, initialSettings)) {
                        render = function (settings) {
                            if (!configuration.onBoot) {
                                return;
                            }
                            configuration.onBoot(__assign(__assign({}, parent), settings));
                        };
                        render(initialSettings);
                    }
                    if (isRenderPageParent(parent, initialSettings)) {
                        render = function (settings) {
                            if (!configuration.renderPage) {
                                return;
                            }
                            configuration.renderPage(settings.pageId, __assign(__assign({}, parent), settings));
                        };
                        listener = render;
                        render(initialSettings);
                    }
                    if (isRenderConfigScreenParent(parent, initialSettings)) {
                        renderUtils_1 = buildRenderUtils(parent);
                        render = function (settings) {
                            if (!configuration.renderConfigScreen) {
                                return;
                            }
                            configuration.renderConfigScreen(__assign(__assign(__assign({}, parent), settings), renderUtils_1));
                        };
                        listener = render;
                        render(initialSettings);
                    }
                    if (isRenderModalParent(parent, initialSettings)) {
                        renderUtils_2 = buildRenderUtils(parent);
                        render = function (settings) {
                            if (!configuration.renderModal) {
                                return;
                            }
                            configuration.renderModal(settings.modalId, __assign(__assign(__assign({}, parent), settings), renderUtils_2));
                        };
                        listener = render;
                        render(initialSettings);
                    }
                    if (isRenderSidebarPaneParent(parent, initialSettings)) {
                        renderUtils_3 = buildRenderUtils(parent);
                        render = function (settings) {
                            if (!configuration.renderItemFormSidebarPanel) {
                                return;
                            }
                            configuration.renderItemFormSidebarPanel(settings.sidebarPaneId, __assign(__assign(__assign({}, parent), settings), renderUtils_3));
                        };
                        listener = render;
                        render(initialSettings);
                    }
                    if (isRenderFieldExtensionParent(parent, initialSettings)) {
                        renderUtils_4 = buildRenderUtils(parent);
                        render = function (settings) {
                            if (!configuration.renderFieldExtension) {
                                return;
                            }
                            configuration.renderFieldExtension(settings.fieldExtensionId, __assign(__assign(__assign({}, parent), settings), renderUtils_4));
                        };
                        listener = render;
                        render(initialSettings);
                    }
                    if (isRenderManualFieldExtensionConfigScreenParent(parent, initialSettings)) {
                        renderUtils_5 = buildRenderUtils(parent);
                        render = function (settings) {
                            if (!configuration.renderManualFieldExtensionConfigScreen) {
                                return;
                            }
                            configuration.renderManualFieldExtensionConfigScreen(settings.fieldExtensionId, __assign(__assign(__assign({}, parent), settings), renderUtils_5));
                        };
                        listener = render;
                        render(initialSettings);
                    }
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=connect.js.map